var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThrdot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.149c-.912 0-1.66.748-1.66 1.66 0 .914.748 1.662 1.66 1.662.913 0 1.662-.748 1.662-1.661s-.748-1.661-1.661-1.661zM9.66 14.149c-.912 0-1.66.748-1.66 1.66 0 .914.748 1.662 1.66 1.662.914 0 1.662-.748 1.662-1.661s-.748-1.661-1.661-1.661zM22.339 14.149c-.913 0-1.661.748-1.661 1.66 0 .914.748 1.662 1.66 1.662.913 0 1.661-.748 1.661-1.661s-.748-1.661-1.66-1.661z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrdot);
export default __webpack_public_path__ + "static/media/thrdot.4d48d848a5b1b67b2d152ce59bdbdbcb.svg";
export { ForwardRef as ReactComponent };